var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNiceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 591,
    height: 558,
    viewBox: "0 0 591 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4906_16827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.615 68.0976L295.365 158.074L205.388 68.0976V0H131.274V98.7279L295.365 262.819L459.729 98.7279V0H385.615V68.0976Z",
    fill: "#0963EB",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.388 488.978L295.638 399.001L385.615 488.978V557.075H459.729V458.347L295.638 294.53L131.274 458.347V557.075H205.388V488.978Z",
    fill: "#0963EB",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.903 369.746L432.926 279.496L522.903 189.246H591V115.405H492.273L328.182 279.496L492.273 443.587H591V369.746H522.903Z",
    fill: "#0963EB",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0976 189.246L158.074 279.769L68.0976 369.746H0V443.587H98.7279L262.819 279.769L98.7279 115.405H0V189.246H68.0976Z",
    fill: "#0963EB",
    fillOpacity: 0.37
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4906_16827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 591,
    height: 557.088,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiceLogo);
export default __webpack_public_path__ + "static/media/niceLogo.4a9e01c22ef47a3c1784aebe9cf5409d.svg";
export { ForwardRef as ReactComponent };